import Vue from 'vue'
import { getRole } from '../service/getData'
import Router from 'vue-router'
import pubmedSearch from '@/components/pubmedSearch'
import login from '@/components/pcLogin'
import weixin from '@/components/weixin'
import mobile from '@/components/mobileBrowser'
import index from '@/views/index'
import baseResult from '@/views/baseResult'
import related from '@/views/related'
import fullText from '@/views/fullText'
import collection from '@/views/collection'
import precisionSearch from '@/views/precisionSearch'
import knowledge from '@/views/knowledge'
import pubMedChart from '@/views/pubMedChart'
import caseList from '@/views/caseList'
import similarCase from '@/views/similarCase'
import caseDetail from '@/views/caseDetail'
import caseAnalysis from '@/views/caseAnalysis'
import conversation from '@/views/conversation'
import clinicalTrials from '@/views/clinicalTrials'
import trialDetail from '@/views/trialDetail'
import similarTrial from '@/views/similarTrials'
import trialAnalysis from '@/views/trialAnalysis'

Vue.use(Router)

export default new Router({
    routes: [{
            path: '/pubmedSearch',
            name: 'pubmedSearch',
            component: pubmedSearch,
            meta: { requiresAuth: true }
        },
        {
            path: '/login',
            name: 'login',
            component: login,
            beforeEnter: (to, from, next) => {
                let token = localStorage.getItem('PUBMEDSEARCHTOKEN');
                if (token) {
                    getRole().then(res => {
                        if (res && res.data.status != 0) { // token失效 或其他非正常错误
                            next();
                        } else {
                            next('/')
                        }
                    })
                } else {
                    next()
                }
            }
        },
        {
            path: '/weixin',
            name: 'weixin',
            component: weixin
        },
        {
            path: '/mobile',
            name: 'mobile',
            component: mobile
        },
        {
            path: '/',
            name: 'index',
            component: index,
            // meta: { requiresAuth: true }
        },
        {
            path: '/baseResult',
            name: 'baseResult',
            component: baseResult,
            meta: { requiresAuth: true }
        },
        {
            path:'/related',
            name:'related',
            component: related,
            meta :{
                requiresAuth : true
            }
          },
        {
            path: '/fullText',
            name: 'fullText',
            component: fullText,
            meta: { requiresAuth: true }
        },
        {
            path: '/collection',
            name: 'collection',
            component: collection,
            meta: { requiresAuth: true }
        },
        {
            path: '/precisionSearch',
            name: 'precisionSearch',
            component: precisionSearch,
            meta: { requiresAuth: true }
        },
        {
            path: '/knowledge',
            name: 'knowledge',
            component: knowledge,
            meta: { requiresAuth: true }
        },
        {
            path: '/pubMedChart',
            name: 'pubMedChart',
            component: pubMedChart,
            meta: { requiresAuth: true }
        },
        {
            path: '/caseList',
            name: 'caseList',
            component: caseList,
            meta: { requiresAuth: true }
        },
        {
            path: '/similarCase',
            name: 'similarCase',
            component: similarCase,
            meta: { requiresAuth: true }
        },
        {
            path: '/caseDetail',
            name: 'caseDetail',
            component: caseDetail,
            meta: { requiresAuth: true }
        },
        {
            path: '/caseAnalysis',
            name: 'caseAnalysis',
            component: caseAnalysis,
            meta: { requiresAuth: true }
        },
        {
            path: '/clinicalTrials',
            name: 'clinicalTrials',
            component: clinicalTrials,
            meta: { requiresAuth: true }
        },
        {
            path: '/trialDetail',
            name: 'trialDetail',
            component: trialDetail,
            meta: { requiresAuth: true }
        },
        {
            path: "/similarTrial",
            name: "similarTrial",
            component: similarTrial,
            meta: { requiresAuth: true }
        },
        {
            path: "/trialAnalysis",
            name: "trialAnalysis",
            component: trialAnalysis,
            meta: { requiresAuth: true }
        },
        {
            path: '/conversation',
            name: 'conversation',
            component: conversation,
            meta: { requiresAuth: true }
        }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js